import { render, staticRenderFns } from "./accidentInfoTL.vue?vue&type=template&id=6493f792"
import script from "./accidentInfoTL.vue?vue&type=script&lang=js"
export * from "./accidentInfoTL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6493f792')) {
      api.createRecord('6493f792', component.options)
    } else {
      api.reload('6493f792', component.options)
    }
    module.hot.accept("./accidentInfoTL.vue?vue&type=template&id=6493f792", function () {
      api.rerender('6493f792', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/timeline/accidentInfoTL.vue"
export default component.exports